export default "/react/logoMaxMetrics-95c156d6.png";